<template>
  <div class="page">
    <div class="page-container">
      <!--        网站首页-->
      <div class="page-tab">
        <img src="../assets/image/page/icon.png"/>
        <div @click="goHome()" class="page-tab-text">网站首页 >></div>
        <span>新闻动态</span>
      </div>
      <!--        文字标题部分-->
      <div class="page-content">
        <div class="page-title">极欧科技助力部分机关老年大学创办网络直播精品课堂</div>
        <div class="page-time">
          <div class="page-line" style="margin-right: 20px"></div>
          2021-01-22 13:53
          <span>编辑：常昊</span>
          <div class="page-line" style="margin-left: 20px"></div>
        </div>
      </div>
      <!--        文字内容部分-->
      <div class="page-product">
        <!--          第一部分-->
        <div class="page-one">
          <div class="page-text">
            今年年初，一场突如其来的疫情打破了人们原有的生活方式，同时也打乱了各机关老年大学春季班的招生计划和教学安排。由于老年人是这次疫情的易感者，集中教学的方式已不可行，亟需探索出一种全新的授课模式，满足老同志求知求学的需求，让老同志始终保持乐观向上的精神面貌助力疫情防控狙击战。
          </div>
          <div class="page-text">
            于是，依托极欧科技直播录播系统及终端播放小程序等技术为基础的“网络直播精品课堂”孵化成功了。数十家机关老年大学自发成立联合教学组，整合优质师资，联合开展线上教学，实现各老年大学之间“开放办学、资源共享”，让老同志宅家学习，畅享精品。
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagesix-1.png"/>
          </div>
          <div class="page-text">
            当时，各校均没有开展网络直播教学的实践经验，一切只能从零起步，在摸索中前进。线上直播教学对于极欧科技而言，也是全新的尝试与挑战。如何满足不同课程的录播需求、如何呈现更好的视听效果、如何丰富使用功能、如何简化操作流程、如何保证直播安全性、如何反馈师生互动……都是极欧科技紧盯不放的细节和着力攻克的难关。
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagesix-2.png"/>
          </div>
          <div class="page-text">
            精品课堂上线后，为确保直播效果，极欧科技工作人员结合自有研发直播系统，每天至少提前一小时到达现场进行课前准备，并根据教学内容，及时做出调整和优化。直播结束后，立即召开现场会议，及时总结直播中存在的问题，商讨改进举措。为了全面了解、准确把握老同志对联合教学活动的需求和评价，工作人员专门设计了调查问卷，主动倾听老同志的诉求，实时更新教学计划。直播实践中，工作人员不放过每一个细节的优化和提高，为在线听课的老同志提供良好的技术保障。
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagesix-3.png"/>
          </div>
          <div class="page-text">
            书法课上，为更方便老同志们看清老师起笔走势，工作人员多次调整机位、布置设备在讲桌上，并在课程中及时切换设备，便于学员们在老师讲课与示范书法时分别观摩不同的角度，学习运笔方式，进一步提升教学效果；绘画课上，为加强老同志们与老师的沟通，工作人员在老师面前投放与电脑直连的提词电视，将直播课程中学员们在互动区域的提出的进行梳理汇集，合并重复和意思相同的问题，将问题整理在题词设备上，在课程尾声进行“访谈式”集中回答，使线上教学互动效果达到甚至超越了线下课堂教学；禅舞课上，为了展示课堂内容的丰富性，更为了学员们有身临其境的现场感，工作人员们多次调整机位、甚至增加设备，将直播课程中参与的学员们一并录入画面、多方位展示，加深老同志们对于舞蹈的理解与学习；为了让没有赶上观看直播的老同志能够尽早回看课程，工作人员在每堂课后都马不停蹄进行编辑整理，确保已直播的课程在半小时内完成“回放教学”。经过极欧科技几个月的持续摸索和改进，在线精品课堂的画面清晰度和播放流畅度都得到了极大的改善。同时，通过不断对机位视角进行调整增设，对音响音质进行升级改进，线上课程几乎还原了线下课堂的真实教学场景，而且其独有的回看功能还为老同志反复温习提供了便利。
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagesix-4.png"/>
          </div>
          <div class="page-text">
            随着极欧科技为各机关老年大学打造的网络直播精品课堂上线后，便利的线上课程学习在老同志间口口相传、声名远播，越来越多的老同志被联合教学组与极欧科技隆重推荐、精心打造的品牌课程所吸引。与此同时，极欧科技积极运营联合教学组公众号，在每日课程结束后都会将本日课程精华摘要汇集至每日公众号文案推送中，方便已听课的老同志巩固学习内容、未听课的老同志有选择性的学习课程；并且在课程迭代更新时，极欧科技结合课程特点、讲师履历，量身定制宣传海报与直播预告，为课程的宣传做出优质的运营。
          </div>
          <div class="pagefive-img-one">
            <img src="../assets/image/page/pagesix-5.png"/>
          </div>
          <div class="page-text">
            截至11月底，收看课程的总浏览累计人数55.7万余人次，每次课参与直播学习和直播回放学习的人数平均都在2000-5000人次不等，参加资源共享的各机关老年大学已超过50多所，目前还不断的有机关单位的老年大学报名加入“网络直播精品课堂”的学习。
          </div>
          <div class="page-text">
            极欧科技为各机关老年大学搭建的网络直播精品课堂平台，不仅实现了各机关教育资源的共享，也提高了课程的品质，提高了教育质量；而老同志可以不受时间地点的限制，天天有学、课课可学、时时可学、处处可学、人人可学，也是顺应互联网时代发展的新型的老年教学模式。
          </div>
          <div class="page-text">
            极欧科技作为一家具备多年积累深耕的行业信息化系统建设经验的新型互联网公司，能够全面满足客户数字化转型的不同需要，为客户提供系统搭建规划、实施方案、运维测试、业务运营、用户管理与广告投放等形态多样的一站式互联网科技服务和产品。
          </div>
          <div class="page-text">
            本次各机关老年大学“网络直播精品课堂”的成功运营，就是又一次完美的解决方案。相信这种新的教学模式将在老同志踊跃参与、积极互动、持续关注、不断转发下成为老年教育新业态并获得持久的生命力。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageSix",
  methods: {
    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped lang="less">
.pagefive-img-one {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
  padding-bottom: 40px;
  img {
    width: 1000px;
    height: 555px;
  }
}

.page {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;

  .page-container {
    margin-bottom: 60px;
    position: relative;
    margin-top: -150px;
    width: 70%;
    background: #FFFFFF;
    padding: 100px 60px 100px 60px;
    box-shadow: 0px 20px 73px 0px rgba(102, 153, 204, 0.2);

    .page-tab {
      padding-top: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;

      img {
        width: 15px;
        height: 20px;
        margin-right: 10px;
      }

      .page-tab-text {
        cursor: pointer;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
      }

      span {
        color: #2368DD;
        margin-left: 10px;
      }
    }

    .page-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .page-title {
        padding-top: 100px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #000000;
        opacity: 0.9;
      }

      .page-time {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 45px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;

        span {
          margin-left: 40px;
        }

        .page-line {
          width: 20%;
          height: 1px;
          background: #000000;
          opacity: 0.2;
        }
      }

    }
    .page-one {
      padding-top: 100px;
      display: flex;
      flex-direction: column;
    }
    .product-title {
      text-indent: 30px;
      padding-top: 40px;
      font-size: 18px;
      color: #5A5A5A;
      font-family: SourceHanSansCN-Normal;
    }

    .page-product {
      display: flex;
      flex-direction: column;
      align-items: center;
      .page-img {
        margin-top: 50px;
      }

      .page-icon {
        padding-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #5A5A5A;

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color:#5A5A5A;
          line-height: 20px;
          opacity: 0.8;
        }
      }

      .page-text {
        margin-top: 20px;
        font-size: 14px;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: #808080;
        line-height: 28px;
        text-indent: 30px;
        opacity: 0.7;
      }

      .page-title {
        text-indent: 30px;
        margin-top: 25px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #5A5A5A;
        line-height: 26px;
        //opacity: 0.7;
      }

      .page-two-text {
        margin-top: 25px;
        line-height: 30px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .page {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .pagefive-img-one {
    img {
      width: 333px;
      height: 185px;
    }
  }
  .page {
    .page-container {
      margin-top: -90px;
      padding: 50px 60px 100px 60px;

      .page-img {
        img {
          width: 260px;
          height: 144px;
        }
      }

      .page-content {
        .page-title {
          text-align: center;
          padding-top: 50px;
          font-size: 20px;
        }

        .page-time {
          .page-line {
            width: 0;
            height: 0;
          }
        }
      }
    }
  }
}

</style>
